/**
 * Separate module to work-around circular dependency:
 * s25-datefilter needs this parser, and s25-util needs dateFilter
 *
 * @author mikhail, devin
 */
import { S25Util } from "../../util/s25-util";

export class s25Dateparser {
    public static parse(rawDate: number | string | Date) {
        if (typeof rawDate === "number") return new Date(rawDate); // Assume number is epoch

        // Invalid Date - return undefined for undefined
        if (!rawDate) {
            return undefined;
        }

        // Date object - clone and return
        if (Object.prototype.toString.call(rawDate) === "[object Date]") {
            return S25Util.date.clone(rawDate) as any;
        }

        let date = window.dayjs(rawDate).toDate() as Date;

        // if date is way back in the past and the rawDate did not include that year
        if (
            date.getFullYear() - new Date().getFullYear() <= -20 &&
            (rawDate as string)?.indexOf(date.getFullYear().toString()) === -1
        ) {
            if (date.getFullYear() >= 1900 && date.getFullYear() <= 1999) {
                // eg, parsed '2/8/51' as 1951, but we can always assume it is this century
                date.setFullYear(new Date().getFullYear() + 100);
            } else {
                // eg, 'march 2' parses as 2001-03-02, but we want it to be CURRENT_YEAR-03-02
                date.setFullYear(new Date().getFullYear());
            }
        }

        return date;
    }
}
